import useNavigation from "@/utils/useNavigate";
import { Image } from "antd-mobile";
import React from "react";

interface BackProps {
  top?: string;
}

const TopBack: React.FC<BackProps> = ({ top = "15px" }) => {
  const { navigateBack } = useNavigation();
  return (
    <Image
      src="https://akim-oss.aikucun.com/ad75772ed0d399f67e8c7a612051c99096df660b_1763104016955_65.png"
      style={{
        width: "28px",
        height: "28px",
        position: "fixed",
        left: "15px",
        top: top,
        zIndex: "2000",
      }}
      onClick={() => navigateBack()}
    />
  );
};

export default TopBack;
